export enum HelpBannerVariant {
  Primary = 'primary',
  Electric = 'electric',
}
